import React from "react";

import styles from "./Overlay.css";

var Overlay = function Overlay(props) {
  return React.createElement("div", { onClick: props.onClick, className: styles.overlay });
};

export default Overlay;


// WEBPACK FOOTER //
// ./src/components/Library/Overlay/Overlay.js